module.exports = __webpack_public_path__ + "img/video call.03dc6eea.svg";